import { AppGlobal } from '@/lib/parse/globals';
import { NavMenuItem } from '@/lib/parse/navigation/navigation';
import Btn from '@/polymorphics/Btn';
import Grid from '@/polymorphics/Grid';
import Txt from '@/polymorphics/Txt';
import Icon from '../Icon';
import * as styles from './Footer.css';

export type FooterBar = {
  items: NavMenuItem[] | undefined;
  linkedin: AppGlobal<'linkedinUrl_GlobalSet'> | undefined;
};

export default function FooterBar({ items, linkedin }: FooterBar) {
  return (
    <Grid cx={{ pY: '3', rowGap: '3' }}>
      <Grid.Col xs={6} md={6} cx={{ display: 'flex', alignItems: 'center' }}>
        <Txt as="p" variant="sm" noMargin cx={{ pR: '2' }}>
          Follow us
        </Txt>
        <Btn
          variant="link"
          type="link"
          href={linkedin?.websiteUrl ?? ''}
          cx={{ mR: 'auto', decoration: 'none' }}>
          <Icon name="linkedin" cx={{ height: '4', width: '4' }} className={styles.linkedin} />
        </Btn>
      </Grid.Col>
      {items?.map((item) => {
        return (
          <Grid.Col
            key={item.id}
            xs={6}
            md={2}
            cx={{
              display: { desktop: 'flex' },
              alignItems: 'center',
              justifyContent: { desktop: 'end' },
            }}>
            <Btn
              variant="link"
              type="link"
              href={item.href ?? ''}
              decoration="hover"
              cx={{
                decoration: 'none',
              }}>
              <Txt as="p" variant="sm">
                {item.title}
              </Txt>
            </Btn>
          </Grid.Col>
        );
      })}
      <Grid.Col
        xs={6}
        md={2}
        cx={{
          display: { desktop: 'flex' },
          alignItems: 'center',
          justifyContent: { desktop: 'end' },
        }}>
        <Txt as="p" variant="sm">
          © Kingfisher {new Date().getFullYear()}
        </Txt>
      </Grid.Col>
    </Grid>
  );
}
